module.exports = __webpack_public_path__ + "static/media/melillo-brain1.dbf45d67.jpg";